import React, { useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { useWindowSize } from "@react-hook/window-size";
import { Row, Col, Input, FormGroup, Label, Button } from "reactstrap";
import Strip from "../customComponent/Strip/Strip";
import ExternalLayout from "../customComponent/ExternalLayout/ExternalLayout";
import RenderPage from "../customComponent/RenderPage/RenderPage";
import SEOComponent from "../customComponent/SEO/SEOComponent";
import CustomPagination from "./Home/CustomPagination";
import getTestData from "../../api/services/TestService";
import getPatients from "../../api/services/getPatients";
import application_contants from "../constants/application_contant";
import Testsdata from "../Utils/Json/TestData";
import VisitService from "../../api/services/VisitService";

const VisitDetails = (props) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const perPage = 10;
  const patientData = props.location.state?.patientData;
  console.log("patient111", patientData);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `http://15.207.223.68:5000/getVisitDetails/${patientData.visitid}`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        console.log("Fetch Result:", result);

        if (result) {
          setData(JSON.parse(result.testdata.reportdata));
          console.log("item", data);
        } else {
          console.error("Invalid response format:", result);
        }
      } catch (error) {
        console.error("Error fetching patient data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  console.log("Data:", data);

  //   useEffect(() => {
  //   console.log("Data Length:", data.length); // Add this log
  // }, [data]);

  return (
    <ExternalLayout>
      <RenderPage
        id="tst-landing"
        className={`render px-0 render-page`}
        containerType="container-fluid"
      >
        <Strip
          id="tst-strip-Video"
          className="strip strip-no-padding "
          containerType="container-fluid mb-5 mt-5"
        >
          <SEOComponent
            title="Test"
            keywords="Test"
            description="Antlia"
            siteUrl="/Antlia"
          />
          <Row className="mx-0 background-container container mx-5">
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={11}
              className="m-auto  pt-4 "
            >
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="pt-3 pl-5 "
                >
                  <p className="p-small title-bold2 align-left">
                    <span className="p-medium section-title title-bold1">
                      Report
                    </span>
                  </p>
                  <div className="custom-box-container">
                    {/* Box Header with Background Color */}
                    <div className="box-header">
                      <p className="p-small pt-1 pl-2 align-left">
                        <span className="p-small section-title title-bold1 ">
                          Patient's Details
                        </span>
                      </p>
                    </div>

                    {/* Box Content */}
                    
                    <div className="box-content">
                      {/* Left Content */}
                      <div className="box-content-left">
                        <p className="title-bold1">{patientData.firstname}</p>
                        <p>{}</p>
                        <p>January 1, 1990</p>
                      </div>

                      {/* Right Content */}
                      <div className="box-content-right">
                        <p>
                          <strong>Doctor's Name:</strong> Dr.Rahul
                        </p>
                        <p>
                          <strong>Hospital Name:</strong>{" "}
                          Manipal Hospital
                        </p>
                      </div>
                    </div>
                  </div>

                  <table className="custom-table section-title pb-3 p-5">
                    <thead>
                      <tr>
                        <th className="p-lesserthan-small">Parameters</th>
                        <th className="p-lesserthan-small">Cut-off</th>
                        <th className="p-lesserthan-small">Act 1</th>
                        <th className="p-lesserthan-small">Act 2</th>
                        <th className="p-lesserthan-small">Act 3</th>
                        <th className="p-lesserthan-small">Act 4</th>
                        <th className="p-lesserthan-small">Act 5</th>
                        <th className="p-lesserthan-small">Act 6</th>
                        <th className="p-lesserthan-small">Pre Ave</th>
                        <th className="p-lesserthan-small">Post Ave</th>
                        <th
                          className="p-lesserthan-small"
                          style={{ width: "9%" }}
                        >
                          Pre% Pred
                        </th>
                        <th
                          className="p-lesserthan-small"
                          style={{ width: "9%" }}
                        >
                          Post% Pred
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item, index) => {
                       
                        return (
                          <tr key={index}>
                            <td className="section-title p-lesserthan-small">
                              {item.title}
                            </td>
                            <td className="p-lesserthan-small">
                              {item.cutoff}
                            </td>
                            <td className="p-lesserthan-small">{item.act1}</td>
                            <td className="p-lesserthan-small">{item.act2}</td>
                            <td className="p-lesserthan-small">{item.act3}</td>
                            <td className="p-lesserthan-small">{item.act4}</td>
                            <td className="p-lesserthan-small">{item.act5}</td>
                            <td className="p-lesserthan-small">{item.act6}</td>
                            <td className="p-lesserthan-small">
                              {item.preAvg}
                            </td>
                            <td className="p-lesserthan-small">
                              {item.postAvg}
                            </td>
                            <td
                              className="p-lesserthan-small"
                              style={{ width: "9%" }}
                            >
                              {item.prePred}
                            </td>
                            <td
                              className="p-lesserthan-small"
                              style={{ width: "9%" }}
                            >
                              {item.postPred}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {/* <div className="pb-5 pt-5">
                   
                    <div className="box-header">
                      <p className="p-small pt-1 pl-2 align-left">
                        <span className="p-small section-title title-bold1 pt-2">
                          Doctor's Comment
                        </span>
                      </p>
                    </div>

                    
                    <div className="">
                     
      
      <Input
        type="textarea"
        name="doctorComment"
        id="doctorComment"
        placeholder="Enter your comment here..."
      />
   

              
                    </div>
                  </div> */}
                </Col>
              </Row>
            </Col>
          </Row>
        </Strip>
      </RenderPage>
    </ExternalLayout>
  );
};

export default VisitDetails;
